import SelectPreference from './SelectPreference/SelectPreference';
import PlayerOptions from './PlayerOptions';
import './RightDrawer.scss';
import { useEventContext } from 'providers/EventProvider';
import { SIDEBAR_WIDTH } from './layout';

import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Checkbox from './Checkbox';
import { Box, Stack } from '@mui/material';
import Splits from './RightSidebar/Splits';
import { useSplitContext } from 'providers/SplitProvider';
import SplitTimes from './RightSidebar/SplitTimes';

const CompetitorsHeader = styled(Stack)({
  fontWeight: 'bold',
  borderBottom: '1px solid rgba(0,0,0,0.4)',
  padding: '5px',
  paddingBottom: '10px',
  marginBottom: 0,
  color: '#ff0060',
  backgroundColor: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  alignItems: 'center'
});

const CompetitorsContainer = styled('div')({
  flex: 1,
  overflowY: 'auto'
});

const DrawerFooter = styled('div')({
  backgroundColor: 'white',
  borderTop: '1px solid rgba(0,0,0,0.12)',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: 4
});

const RightDrawer = (props: RightDrawerProps) => {
  const { open, setOpen } = props;

  const { players, updatePlayers, options, updateOptions } = useEventContext();
  const { activeSplits } = useSplitContext();

  const onChangeAllPlayersShow = () => {
    const show = !options.showAllPlayers;
    updatePlayers((current) => [...current.map((player) => ({ ...player, options: { ...player.options, show } }))]);
    updateOptions((current) => ({ ...current, showAllPlayers: show }));
  };

  return (
    <Drawer
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1000,
        width: open ? SIDEBAR_WIDTH : 0,
        minWidth: 0,
        height: '100%',
        overflow: 'hidden',
        pointerEvents: open ? 'auto' : 'none',
        transition: 'width 0.2s ease',
        '& .MuiDrawer-paper': {
          width: SIDEBAR_WIDTH,
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          border: 'none',
          borderLeft: '1px solid #f0f0f2',
          boxShadow: '-4px 0 16px rgba(0, 0, 0, 0.12)'
        }
      }}
      variant="persistent"
      anchor="right"
      open={open}
    >
      <CompetitorsHeader direction="row">
        <Checkbox checked={options.showAllPlayers} onClick={onChangeAllPlayersShow} />
        <Box sx={{ flex: 1 }}>All Competitors</Box>
        <IconButton onClick={() => setOpen(false)} size="small" sx={{ color: '#ff0060' }} aria-label="Close competitors">
          <ChevronRightIcon />
        </IconButton>
      </CompetitorsHeader>
      <CompetitorsContainer>
        {players.map((player, index) => (
          <PlayerOptions key={player.id || index} player={player} />
        ))}
        <Splits />
        {activeSplits.length > 0 && <SplitTimes all={true} />}
      </CompetitorsContainer>
      <DrawerFooter>
        <SelectPreference />
      </DrawerFooter>
    </Drawer>
  );
};

export default RightDrawer;

type RightDrawerProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};
